import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;